import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import ContactImg from './Images/contact-img.png';

function ContactForm() {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        contactNumber: '', // New
        subject: '',
        email: '',
        message: '',
        service: '',
        attachment: null, // New
        errors: {}
    });

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'attachment') {
            setFormData({ ...formData, [name]: files[0] });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleFocus = (e) => {
        e.target.parentNode.querySelector('label').classList.add('active');
    };

    const handleBlur = (e) => {
        if (!e.target.value) {
            e.target.parentNode.querySelector('label').classList.remove('active');
        }
    };

    const [submitting, setSubmitting] = useState(false);
    const [submitMsg, setSubmitMsg] = useState(null);
    const [submitSuccess, setSubmitSuccess] = useState(null);

    // PHP endpoint for form handling
    const PHP_ENDPOINT = 'https://fusion-hub.us/sendmail.php';

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { firstName, lastName, contactNumber, subject, email, message, service } = formData;

        const errors = {};
        if (!firstName) errors.firstName = 'First Name is required';
        if (!lastName) errors.lastName = 'Last Name is required';
        if (!email) errors.email = 'Email is required';
        if (!contactNumber) errors.contactNumber = 'Contact Number is required';
        if (!subject) errors.subject = 'Subject is required';
        if (!message) errors.message = 'Message is required';
        if (!service) errors.service = 'Service selection is required';

        if (Object.keys(errors).length > 0) {
            setFormData({ ...formData, errors });
            return;
        }

        setSubmitting(true);
        setSubmitMsg(null);
        setSubmitSuccess(null);

        try {
            // Prepare FormData for file upload
            const formDataToSend = new FormData();
            formDataToSend.append('firstName', formData.firstName);
            formDataToSend.append('lastName', formData.lastName);
            formDataToSend.append('contactNumber', formData.contactNumber);
            formDataToSend.append('subject', formData.subject);
            formDataToSend.append('email', formData.email);
            formDataToSend.append('message', formData.message);
            formDataToSend.append('service', formData.service);
            if (formData.attachment) {
                formDataToSend.append('attachment', formData.attachment);
            }

            const res = await fetch(PHP_ENDPOINT, {
                method: 'POST',
                body: formDataToSend
            });

            const result = await res.json();

            if (result.success) {
                setSubmitMsg('Your message has been sent successfully!');
                setSubmitSuccess(true);
                setFormData({
                    firstName: '',
                    lastName: '',
                    contactNumber: '',
                    subject: '',
                    email: '',
                    message: '',
                    service: '',
                    attachment: null,
                    errors: {}
                });
            } else {
                setSubmitMsg(result.message || 'Failed to send your message.');
                setSubmitSuccess(false);
            }
        } catch (err) {
            setSubmitMsg(err.message || 'Failed to send your message.');
            setSubmitSuccess(false);
        } finally {
            setSubmitting(false);
        }
    };


    const { firstName, lastName, contactNumber, subject, email, message, errors } = formData;

    return (
        <>
            <Helmet>
                <title>Contact FusionHub | Get in Touch</title>
                <meta name="description" content="Reach out to FusionHub for business inquiries, support, or partnership opportunities." />
                <meta name="keywords" content="FusionHub, contact, business, support, inquiry, quotation" />
            </Helmet>
            <div className="row justify-content-center">
                <div className="col-xl-4 col-lg-5">
                    <img src={ContactImg} alt="Contact" />
                </div>
                <div className="col-lg-7 offset-xl-1">
                    <form className="FusionHub-form-wrap mt-5 mt-lg-0" onSubmit={handleSubmit}>
                        <div className="row custom-gutters-16">
                            <div className="col-md-6">
                                <div className={`single-input-wrap mb-4 ${errors.firstName && 'error'}`}>
                                    <input type="text" name="firstName" value={firstName} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} className="single-input mb-0" />
                                    <label>First Name</label>
                                    {errors.firstName && <span className="error-text text-danger">{errors.firstName}</span>}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className={`single-input-wrap mb-4 ${errors.lastName && 'error'}`}>
                                    <input type="text" name="lastName" value={lastName} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} className="single-input mb-0" />
                                    <label>Last Name</label>
                                    {errors.lastName && <span className="error-text text-danger">{errors.lastName}</span>}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className={`single-input-wrap mb-4 ${errors.email && 'error'}`}>
                                    <input type="email" name="email" value={email} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} className="single-input mb-0" />
                                    <label>Email</label>
                                    {errors.email && <span className="error-text text-danger">{errors.email}</span>}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className={`single-input-wrap mb-4 ${errors.contactNumber && 'error'}`}>
                                    <input type="text" name="contactNumber" value={contactNumber} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} className="single-input mb-0" />
                                    <label>Contact Number</label>
                                    {errors.contactNumber && <span className="error-text text-danger">{errors.contactNumber}</span>}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className={`single-input-wrap mb-4 ${errors.service && 'error'}`}>
                                    <select
                                    name="service"
                                    className="single-input mb-0"
                                    value={formData.service}
                                    onChange={handleChange}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                >
                                        <option value="" disabled selected>Select a Service</option>

                                        <optgroup label="Civil Services">
                                            <option value="Interior Fit Out Cost Estimation">Interior Fit Out Cost Estimation</option>
                                            <option value="BOQ / Material Takeoff">BOQ (Bill of Quantities) / Material Takeoff</option>
                                            <option value="Tender Support & Bidding Solutions">Tender Support & Bidding Solutions</option>
                                        </optgroup>

                                        <optgroup label="Solar Services">
                                            <option value="Load Audits">Load Audits</option>
                                            <option value="System Design">System Design</option>
                                            <option value="Cost Estimation & Material Takeoff">Cost Estimation & Material Takeoff</option>
                                            <option value="Procurement Assistance">Procurement Assistance</option>
                                        </optgroup>

                                        <optgroup label="Lighting Services">
                                            <option value="Lighting Design">Lighting Design</option>
                                            <option value="Cost Analysis & Material Planning">Cost Analysis & Material Planning</option>
                                            <option value="Product Sourcing & Procurement">Product Sourcing & Procurement</option>
                                        </optgroup>

                                        <optgroup label="Analytics">
                                            <option value="SAP Analytics">SAP Analytics</option>
                                            <option value="SAP Analytics Cloud (SAC)">SAP Analytics Cloud (SAC)</option>
                                            <option value="Power BI & Tabular Models">Power BI & Tabular Models</option>
                                        </optgroup>

                                        <optgroup label="Web Development">
                                            <option value="CMS Platforms">CMS Platforms</option>
                                            <option value="Custom & Basic Website Development">Custom & Basic Website Development</option>
                                            <option value="AI Integrations & Automation">AI Integrations & Automation</option>
                                            <option value="Full Website Management">Full Website Management</option>
                                        </optgroup>

                                        <optgroup label="AI Solutions">
                                            <option value="Custom Software Development">Custom Software Development</option>
                                            <option value="AI Powered Website Features">AI Powered Website Features</option>
                                            <option value="Chatbot Integration for eCommerce">Chatbot Integration for eCommerce</option>
                                        </optgroup>

                                        <optgroup label="App & Software">
                                            <option value="App & Software">App & Software</option>
                                        </optgroup>

                                        <optgroup label="Marketing">
                                            <option value="Social Media Marketing">Social Media Marketing</option>
                                            <option value="Search Engine Optimization (SEO)">Search Engine Optimization (SEO)</option>
                                            <option value="Google Ads/PPC">Google Ads/PPC</option>
                                        </optgroup>

                                        <optgroup label="HR Services">
                                            <option value="HR & Administrative Services">HR & Administrative Services</option>
                                            <option value="Accounting & Finance">Accounting & Finance</option>
                                            <option value="Cold Calling & Lead Outreach">Cold Calling & Lead Outreach</option>
                                            <option value="Engineering Support Staff">Engineering Support Staff</option>
                                        </optgroup>

                                        <optgroup label="Business Operations">
                                            <option value="Logistics Coordination">Logistics Coordination</option>
                                            <option value="Inventory Management">Inventory Management</option>
                                            <option value="E-commerce Store Management">E-commerce Store Management</option>
                                        </optgroup>

                                        <optgroup label="Financial Services">
                                            <option value="Financial Services">Financial Services</option>
                                        </optgroup>

                                        <optgroup label="Administrative Services">
                                            <option value="Administrative Services">Administrative Services</option>
                                        </optgroup>
                                    </select>

                                    <label className="active">Service</label>
                                    {errors.service && <span className="error-text text-danger">{errors.service}</span>}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className={`single-input-wrap mb-4 ${errors.subject && 'error'}`}>
                                    <input type="text" name="subject" value={subject} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} className="single-input mb-0" />
                                    <label>Subject</label>
                                    {errors.subject && <span className="error-text text-danger">{errors.subject}</span>}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className={`single-input-wrap mb-4 ${errors.message && 'error'}`}>
                                    <textarea className="single-input mb-0 textarea" name="message" value={message} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
                                    <label>Message</label>
                                    {errors.message && <span className="error-text text-danger">{errors.message}</span>}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="single-input mb-0-wrap mb-4">
                                    <input type="file" name="attachment" onChange={handleChange} className="single-input mb-0" />
                                    <label className="active">Attachment (PDF, Word, Excel, etc.)</label>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="submit" className="btn btn-black-border mt-0">Get a Quotation</button>
                            </div>
                        </div>
                    </form>
                    <div style={{ minHeight: 40, marginTop: 16 }}>
                        {submitting && (
                            <div className="form-loader" style={{ textAlign: 'center' }}>
                                <div className="spinner" style={{ display: 'inline-block', width: 32, height: 32, border: '4px solid #eee', borderTop: '4px solid #0d3a6b', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
                                <style>{`@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}`}</style>
                                <div style={{ marginTop: 8, color: '#888' }}>Submitting...</div>
                            </div>
                        )}
                        {submitMsg && (
                            <div style={{
                                textAlign: 'center',
                                color: submitSuccess ? '#219150' : '#d32f2f',
                                background: submitSuccess ? '#eafaf1' : '#fdeaea',
                                border: submitSuccess ? '1px solid #b6e5c7' : '1px solid #f3bcbc',
                                borderRadius: 6,
                                padding: '10px 0',
                                fontWeight: 500,
                                marginTop: submitting ? 12 : 0
                            }}>
                                {submitMsg}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContactForm;
